import React from 'react';
import withAuthentication from '../Session/withAuthentication';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-table/react-table.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Layout from '../Layout';

const App = () =>
    <div className="app">
      <Layout></Layout>
      <ToastContainer />
    </div>

export default withAuthentication(App);


// WEBPACK FOOTER //
// ./src/components/App/index.js